import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class FundrecommService {

  constructor(private http: HttpClient) { }

  get_fundRecomList_top3() {
    let _latestNewsUrl = cmsApi + '/get_fundRecomList_top3/'
    let _latestNewsBody = {}
    return this.http.post(_latestNewsUrl, _latestNewsBody)
  }

  get_marketList_top3() {
    let _latestNewsUrl = cmsApi + '/get_marketList_top3/'
    let _latestNewsBody = {}
    return this.http.post(_latestNewsUrl, _latestNewsBody)
  }

  get_vdoList_top3() {
    let _latestNewsUrl = cmsApi + '/get_vdoList_top3/'
    let _latestNewsBody = {}
    return this.http.post(_latestNewsUrl, _latestNewsBody)
  }

  get_newsletterList_top3() {
    let _latestNewsUrl = cmsApi + '/get_newsletterList_top3/'
    let _latestNewsBody = {}
    return this.http.post(_latestNewsUrl, _latestNewsBody)
  }


  getvdo_list_notTop3() {
    let _latestNewsUrl = cmsApi + '/getvdo_list_notTop3/'
    let _latestNewsBody = {}
    return this.http.post(_latestNewsUrl, _latestNewsBody)
  }

  getnewsletter_listNotTop3() {
    let _latestNewsUrl = cmsApi + '/getnewsletter_listNotTop3/'
    let _latestNewsBody = {}
    return this.http.post(_latestNewsUrl, _latestNewsBody)
  }



  get_fundRecomList() {
    let _getNewsPeriodUrl = cmsApi + '/get_fundRecomList_active/'
    let _getNewsPeriodBody = { IsActive: '1', search: '' }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_fundRecomById(fundRecomid) {
    let URL = cmsApi + '/get_fundRecomById';
    let body = { fundRecomid: fundRecomid };

    return this.http.post(URL, body);
  }


  get_newsletterById(newsletter_id) {
    let URL = cmsApi + '/get_newsletterById';
    let body = { newsletter_id: newsletter_id };

    return this.http.post(URL, body);
  }

  get_vdoById(vdo_id) {
    let URL = cmsApi + '/get_vdoById';
    let body = { vdo_id: vdo_id };

    return this.http.post(URL, body);
  }

  changeFormatDate(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day + ' ' + monthTh['name'] + ' ' + year;
    }
  }


  changeFormatDate_getdate(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day;
    }
  }

  changeFormatDate_getMMyyyy(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return monthTh['name'] + ' ' + year;
    }
  }
  
  changeFormatDate_getDateEnd(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month_week = d.getMonth();
      const end_of_month = new Date(d.getFullYear(), month_week + 1, 0);
      const first_day = new Date(d.getFullYear(), month_week, 1);

      return first_day.getDate() + '-' + end_of_month.getDate();
    }
  }


  date_thai(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (day + ' ' + monthTh['name'] + ' ' + year);
  }

  date_thai_dd(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (day);
  }

  date_thai_mm(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (monthTh['name']);
  }

  date_thai_yy(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] == month)[0];
    return (year);
  }

  checkMonth: Array<Object> = [
    {
      number: 1,
      name: 'มกราคม'
    },
    {
      number: 2,
      name: 'กุมภาพันธ์'
    },
    {
      number: 3,
      name: 'มีนาคม'
    },
    {
      number: 4,
      name: 'เมษายน'
    },
    {
      number: 5,
      name: 'พฤษภาคม'
    },
    {
      number: 6,
      name: 'มิถุนายน'
    },
    {
      number: 7,
      name: 'กรกฎาคม'
    },
    {
      number: 8,
      name: 'สิงหาคม'
    },
    {
      number: 9,
      name: 'กันยายน'
    },
    {
      number: 10,
      name: 'ตุลาคม'
    },
    {
      number: 11,
      name: 'พฤศจิกายน'
    },
    {
      number: 12,
      name: 'ธันวาคม'
    }
  ];

}
